module.exports = __webpack_public_path__ + "img/6354613683085012509517641.6244c47b.jpg";